<template>
  <div>
    <el-cascader
      size="mini"
      :show-all-levels="true"
      placeholder="请选择教育厅"
      style="width: 100%"
      v-model="eduId"
      :options="eduData"
      :props="defaultProps"
      @change="handleChange"
    >
    </el-cascader>
  </div>
</template>
<script>
export default {
  name: "eduSelect",
  props: {
    value: {
      type: String,
      default: {
        return: "",
      },
    },
    isEditSatus: {
      type: Boolean,
      default: {
        return: false,
      },
    },
    addResize: {
      type: Number,
      default: {
        return: 0,
      },
    },
  },
  data() {
    let _this = this;
    return {
      eduData: [],
      first: 1,
      defaultProps: {
        checkStrictly: false,
        multiple: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          // console.log(this)
          // console.log(11111)
          // console.log(node.value);
          const { level } = node;
          console.log(level);
          let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
          let eduBuresuType = eduInfo.eduBuresuType;
          let maxLevel = 0;
          if (eduBuresuType == 0) {
            maxLevel = 3;
          } else if (eduBuresuType == 1) {
            maxLevel = 2;
          } else {
            maxLevel = 1;
          }

          let req = {};
          if (level == 0) {
            req = {
              // eduId: eduInfo.eduId,
              curEduId: eduInfo.eduId,
            };
          } else {
            req = {
              eduId: node.value,
              curEduId: eduInfo.eduId,
            };
          }
          console.log(req);
          let res = await _this.$Http.getEduDataList(req);
          if (res.code == 200) {
            let nodes = res.data.map((item) => ({
              value: item.eduId,
              label: item.eduBuresuName,
              leaf: level >= maxLevel,
            }));

            resolve(nodes);
          } else if (res.code == -1) {
            res.data = [];
            let nodes = res.data.map((item) => ({
              value: item.eduId,
              label: item.eduBuresuName,
              leaf: level >= maxLevel,
            }));
            resolve(nodes);
          } else {
            res.data = [];
            let nodes = res.data.map((item) => ({
              value: item.eduId,
              label: item.eduBuresuName,
              leaf: level >= maxLevel,
            }));
            resolve(nodes);
          }
        },
      },
      eduId: [],
    };
  },
  created() {},
  mounted() {},
  watch: {
    addResize: {
      handler(newVal, oldVal) {
        // console.log(newVal)
        if (!this.isEditSatus) {
          // console.log(2222)
          this.eduId = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 获取数据列表
    // async getEduList() {
    //   this.eduData = [];
    //   let res = await this.$Http.getEduDataList({
    //     eduId: this.$store.getters.getEduData.eduId
    //   });
    //   console.log(res)
    //   return res.data;
    //   // if (res.code == 200) {
    //   //   // this.eduData.push(res.data || {});
    //   //   // this.geteduIdList(this.value);
    //   // } else if (res.code == -1) {
    //   //   this.eduData = [];
    //   // } else {
    //   //   this.eduData = [];
    //   // }
    // },
    // 点击节点时触发
    handleChange(data) {
      console.log(data, 999);
      // this.$emit("input", data[data.length - 1] + "");
      // let eduId;
      // if (data.length > 0) {
      //   // console.log(data[data.length - 1]);
      //   eduId = data[data.length - 1];
      // } else {
      //   // console.log(data);
      //   eduId = JSON.parse(sessionStorage.getItem("eduInfo")).eduId;
      // }

      // this.$emit("input", eduId + "");
    },
  },
};
</script>
<style scoped></style>
